import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const Tonnage = (props) => {
  return (
    <FormGroup controlId="tonnage">
      <Col componentClass={ControlLabel} sm={5}>
        Cubic Capacity/Tonnage
      </Col>
    <Col sm={7}>
        <FormControl
          type="text"
          value={props.tonnage}
          onChange={props.handleChangeTonnage}
          maxLength="40"
          autoComplete="off"
          />
    </Col>
    </FormGroup>
  )
}

Tonnage.propTypes = {
  tonnage: PropTypes.string,
  handleChangeTonnage: PropTypes.func,

};

export default Tonnage;



// WEBPACK FOOTER //
// ./src/app/components/coverNoteCVComponent/tonnage/Tonnage.js